module.exports = __webpack_public_path__ + "static/img/monitiornew3.8a8ca6d3.webp";